import { render } from "./FamiliaDetalle.vue?vue&type=template&id=11ff5a4c&ts=true"
import script from "./FamiliaDetalle.vue?vue&type=script&lang=ts"
export * from "./FamiliaDetalle.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__